// A US-layout scanner types "-" as the key a Spanish keyboard reads as "'".
const SCANNED_HYPHEN = /([A-Za-z]{2,4})'(\d+)/g

export function normalizeScannedCode(value) {
  return String(value || '').replace(SCANNED_HYPHEN, '$1-$2')
}
